import { Injectable } from '@angular/core';
import { PaginatedResult } from 'src/app/shared/grid/paginate.model';
import { Observable, of } from 'rxjs';
import { IPaginatedServiceParamters } from '../core/models/ITable';
import { Property } from '../core/models/Property';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class PropertyService {
  constructor(private apiService: ApiService) {}

  getAllPaginated(
    paginatedArguments: IPaginatedServiceParamters,
  ): Observable<PaginatedResult<Property[]>> {
    return this.apiService.getPaginated('/api/property', paginatedArguments);
  }

  searchProperties(
    query?,
    page?,
    itemsPerPage?,
  ): Observable<PaginatedResult<Property[]>> {
    var paginatedArguments: IPaginatedServiceParamters = {
      pageNumber: page,
      pageSize: itemsPerPage,
      query: query,
    };
    
    // Si no hay query o está vacía, devolver todas las propiedades
    if (!query || query.trim() === '') {
      return this.apiService.getPaginated('/api/property', paginatedArguments);
    }
    
    // Si hay query, verificar que tenga al menos 3 caracteres después del =
    const queryValue = query.includes('=') ? query.substring(query.indexOf('=')+1) : query;
    return queryValue.length > 2 ? 
      this.apiService.getPaginated('/api/Property/Address', paginatedArguments) : 
      of({ 
        result: [], 
        pagination: { 
          currentPage: page || 1, 
          itemsPerPage: itemsPerPage || 5, 
          totalItems: 0, 
          totalPages: 0 
        } 
      });
  }

  getProperty(id) : Observable<Property> {
    return this.apiService.get(`/api/property/${id}`);
  }

  deleteProperty(id) {
    return this.apiService.delete(`/api/property/${id}`);
  }

  updateProperty(id, updateProperty) {
    return this.apiService.put(`/api/property/${id}`, updateProperty);
  }

  createProperty(newProperty) {
    return this.apiService.post(`/api/property`, newProperty);
  }

  downloadCSV(filters: any): Observable<Blob> {
    return this.apiService.getBlob('/api/Property/DownloadCSV', filters);
  }

  downloadExcel(filters: any): Observable<Blob> {
    return this.apiService.getBlob('/api/Property/DownloadExcel', filters);
  }
}
